import { render, staticRenderFns } from "./hedgeAmountDetail.vue?vue&type=template&id=83f0a022&scoped=true"
import script from "./hedgeAmountDetail.vue?vue&type=script&lang=js"
export * from "./hedgeAmountDetail.vue?vue&type=script&lang=js"
import style0 from "./hedgeAmountDetail.vue?vue&type=style&index=0&id=83f0a022&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f0a022",
  null
  
)

export default component.exports